import { render, staticRenderFns } from "./ServidoresOLTPlacaUplink.vue?vue&type=template&id=72dd18c9&"
import script from "./ServidoresOLTPlacaUplink.vue?vue&type=script&lang=js&"
export * from "./ServidoresOLTPlacaUplink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports